import styled from "styled-components";

export const HomepageTopBannerDividerBox = styled.div`
    @media ${({theme}) => theme.mediaQuery.lAndBelow} {
        box-sizing: border-box;
        display: block;
        width: calc(100% - 14px);
        background-color: ${props => props.theme.colors.dividerTopBorder};
        border-top: 3px solid ${props => props.theme.colors.dividerBottomBorder};
        border-bottom: 1px solid ${props => props.theme.colors.dividerTopBorder};
        margin: 4px 0 7px 7px;
    }
`;
